enum UserOperationStatus {
  StartToUse = 'REIMBURSEMENTS_START_TO_USE_VISIBILITY',
}

export default UserOperationStatus
